//Need to establish functionality - no code provided
import React from "react";

const Explore = () => {
  return (<div>UNDER CONSTRUCTION</div>)
}

export default Explore;
